<script>
    export let params = {};
</script>

<div class="app-container mt-6 mb-6">
    { params.contact }
    <div class="box has-text-centered">
        <br>
        <!-- <h1 class="is-size-4"><strong>Thank you very much for <span class="has-text-success">confirming</span>!</strong></h1> -->
        <h1 class="is-size-4"><strong>One more step away!</strong></h1>
        <br>
        <a class="button has-background-info has-text-white is-medium" href="https://us-central1-sms-system-853de.cloudfunctions.net/optInConfirmation?id={ params.contact }"><b>Click to opt-in</b></a>
        <br>
    </div>
</div>